import { GroupEventType } from '@moovly/clients/lib/resources/bi/bi.interfaces';
import { t } from '@moovly/i18n';

const eventTranslations: { [TKey in GroupEventType]: string } = {
  'create-membership': 'statistics.events.type.createMembership',
  'delete-membership': 'statistics.events.type.deleteMembership',
  'buy-group-license': 'statistics.events.type.buyGroupLicense',
  'assign-group-license': 'statistics.events.type.assignGroupLicense',
  'revoke-group-license': 'statistics.events.type.revokeGroupLicense',
  'update-membership': 'statistics.events.type.updateMembership',
};
export const eventTypes = [
  'create-membership',
  'delete-membership',
  'buy-group-license',
  'assign-group-license',
  'revoke-group-license',
  'update-membership',
];

const getEventTypesSelect: () => {
  value: GroupEventType;
  label: string;
}[] = () =>
  (Object.keys(eventTranslations) as GroupEventType[]).map((key: GroupEventType) => ({
    value: key,
    label: t(eventTranslations[key]),
  }));

export { getEventTypesSelect, eventTranslations };
